import './ApiBlockInputDropdown.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import VariableDropdown from '../../../Variables/VariablesDropdown/VariablesDropdown';
import { useBotStateContext } from '/src/features/editor/contexts/BotContext';
import { useState,useRef, useEffect } from 'react';

function ApiBlockInputDropdown ({KeyValue, value, deleteValue, idx, setValue}) {

    const { variables } = useBotStateContext();

    const cleanInput = (val) => val.replace(/\[/g,'').replace(/\]/g,'');

    const isVariableFind = (val) => {
        val = cleanInput(val);
        return variables.filter( variable => variable.name == val.toLowerCase()).length > 0;
    };

    const [keyRow, setKeyRow] = useState(KeyValue);
    const [valueRow, setValueRow] = useState(value ? `[${value}]` : '');

    const onBlur = () => {
        const valueRowTmp = cleanInput(valueRow);
        setValueRow(valueRowTmp ? `[${valueRowTmp}]` : '');
        setValue(idx, 'value', valueRowTmp)
    }
    useEffect( ()=>{
        setValueRow(value ? `[${value}]` : '');
        setKeyRow(KeyValue)
    }, [value])
    return (
        <div className='form_sub_block'>
            <TextInput className="editor-input-sub" placeholder="key" value={keyRow} onChange={(e) => setKeyRow(e.target.value)} onBlur={() => setValue(idx, 'key', keyRow)}/>
            <TextInput className="editor-input-sub uppercase" placeholder="value" value={valueRow} style={{ color : isVariableFind(value) ? 'var(--main)' : 'var(--black)'}} onChange={(e) => {setValueRow(e.target.value.toUpperCase())}} onBlur={onBlur}/> 
            <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => deleteValue(idx)}/>
        </div>
    )
}

export default ApiBlockInputDropdown;